/** The web's AvatarUrlContext hook: a stored `drive-file:<id>` photo is exchanged for its access link, the
 *  same cached resolution the web Avatar component uses; any direct URL passes straight through. */
import React from 'react';
import { directAvatarUrl } from '../../shared-ui/avatarUrl';
import { parseDriveAvatarFileId, resolveDriveAvatarAccessUrl } from './avatar';

export function useWebAvatarUrl(reference?: string | null): string | undefined {
  const fileId = parseDriveAvatarFileId(reference);
  const [resolved, setResolved] = React.useState<{ fileId: string; url: string } | null>(null);
  React.useEffect(() => {
    if (!fileId) return;
    let cancelled = false;
    resolveDriveAvatarAccessUrl(fileId)
      .then((url) => { if (!cancelled) setResolved({ fileId, url }); })
      // A photo that cannot be resolved shows initials; the Avatar component already logs the transport issue once.
      .catch(() => { if (!cancelled) setResolved(null); });
    return () => { cancelled = true; };
  }, [fileId]);
  if (!fileId) return directAvatarUrl(reference);
  return resolved?.fileId === fileId ? resolved.url : undefined;
}
